import React from "react";
import FigmaBadge from "../Elements/FigmaBadge";
import dateTimeHelper from "../Helpers/datetimeHelper";
import urlHelper from "../Helpers/urlHelper";

export default class RelatedContactItem {
  constructor(item) {
    if (item === undefined) {
      this.ContactId = "";
      this.Name = "";
      this.OfficeName = "";
      this.AddressName = "";
      this.BusinessPhone = "";
      this.Email = "";
      this.IsActive = "";
      this.ModifiedOn = "";
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.ContactId = item.contactId;
    this.Name = item.name;
    this.OfficeName = item.officeName;
    this.AddressName = item.addressName;
    this.BusinessPhone = item.businessPhone;
    this.Email = item.email;
    this.IsActive = item.isActive;
    this.ModifiedOn = item.modifiedOn;
  }

  static NameOfTheIdField() {
    return "AddressId";
  }
  static nameOfTheItemDetailList() {
    return "Address";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = ["CreatedOn", "ModifiedOn"];

  static BoolFields = ["IsActive"];

  static FieldsToShowInListTable = [{ tabName: "General", tabLabel: "General", icon: "fa-solid fa-users", data: [{ name: "AddressId", label: "Address Id" }] }];

  static getIsActiveCellContent(item) {
    return (
      <div className="pointer">
        {
          <FigmaBadge
            Active={item}
            ActiveText="Yes"
            InactiveText="No"
            width={55}
          />
        }
      </div>
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: "Id", orderById: "ContactId", data: RelatedContactItem.GetNavigationCellContent, minWidth: 50 },
      { label: "Name", orderById: "Name", data: "Name", minWidth: 50 },
      { label: "Office", orderById: "OfficeName", data: "OfficeName", minWidth: 50 },
      { label: "Address", orderById: "AddressName", data: "AddressName", minWidth: 50 },
      { label: "BusinessPhone", orderById: "BusinessPhone", data: "BusinessPhone", minWidth: 50 },
      { label: "Email", orderById: "Email", data: "Email", minWidth: 50 },
      { label: "Is Active?", orderById: "IsActive", data: (item) => RelatedContactItem.getIsActiveCellContent(item.IsActive), minWidth: 50 },
      { label: "Modified On", orderById: "ModifiedOn", data: (item) => dateTimeHelper.toYYYYsMMsDD(item.ModifiedOn), minWidth: 50 },
    ];
  }

  static GetNavigationCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.ContactId,
      "fa-solid fa-arrow-up-right-from-square",
      "text-primary pl-1 pr-1",
      "sales_contacts/search",
      "ContactId=" + item.ContactId + "&IsActive=&OfficeId=",
      "Open up in a new tab"
    );
  }

  static getContactIdCellContent(item) {
    return (
      <div
        onClick={() => RelatedContactItem.clickOnContactId(item.ContactId)}
        className="secondarylink"
        style={{ cursor: "pointer" }}
      >
        {item.ContactId}
      </div>
    );
  }

  static clickOnContactId() {
    //this is just a placeholder
    alert("akármi");
  }
}
